var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpareTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667ZM10 4.16667C10.4602 4.16667 10.8333 4.53976 10.8333 5V10.4882L13.9186 13.5734C14.244 13.8988 14.244 14.4264 13.9186 14.7519C13.5931 15.0773 13.0655 15.0773 12.74 14.7519L9.41074 11.4226C9.25994 11.2718 9.16667 11.0635 9.16667 10.8333V5C9.16667 4.53976 9.53976 4.16667 10 4.16667Z",
    fill: "#060606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpareTimeIcon);
export default __webpack_public_path__ + "static/media/spare-time--icon.ddcdcef14c70169cd277b66aef5d7579.svg";
export { ForwardRef as ReactComponent };